import "./globals.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Providers } from "./Providers";
import { Explorer } from "./mud/Explorer";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./ui/ErrorFallback";
import { router } from "./router";
import { RouterProvider } from "@tanstack/react-router";

createRoot(document.getElementById("react-root")!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Providers>
        <RouterProvider router={router} />. 
        <Explorer />
      </Providers>
    </ErrorBoundary>
  </StrictMode>,
);
